<!--
  cfntYnCnf.vue ( 4 step, mblElcSgn15 )
  - 대면설명여부 계약자확인
 -->
<template>
  <div id="wrap" class="wrap_layout">
    <Header :rtrnAnimInsYn="state.rtrnAnimInsYn" />
    <!--Container [s]-->
    <div class="container">
      <div class="contents">
        <!--Contents Area [s]-->
        <div class="section">
          <p class="tit mgt0">서명란</p>
          <div class="txt_confirm_wrap">
            <p>
              영업담당자 <strong class="point">{{ state.trtpeOrgNm }}</strong
              >(은)는 고객
              <strong class="point">{{ astaFormat(state.maInspeNm) }}</strong
              >님을 직접 대면하여 상품 및 계약내용에 대해 충실히 설명하였고,
              청약서 부본(각 항목 설명, 확인 및 동의서 포함) 및 약관을
              전달하였으며, 고객에게 제공되는 상품설명서의 내용과 영업담당자가
              고객에게 설명한 내용이 동일합니다.
            </p>
            <p>
              상기 내용에 대한 모든 책임을 질 것에 대하여 영업담당자가
              <strong class="point02">{{ state.yyyymmdd }}</strong
              >에 확인 및 서명하였습니다.
            </p>
            <p>
              영업담당자 <strong class="point">{{ state.trtpeOrgNm }}</strong
              >(으)로부터 직접 설명듣고 안내받은 사실이 맞을 경우 자필서명하시기
              바랍니다.
            </p>
          </div>
          <p class="tit_tbl">계약기본사항</p>
          <div class="data_table type_row data">
            <table>
              <caption class="blind">
                계약기본사항
              </caption>
              <colgroup>
                <col style="width: 78px" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">설명방법</th>
                  <td>{{ state.inspeCfntDscMd }}</td>
                </tr>
                <tr>
                  <th scope="row">대면일시</th>
                  <td>{{ state.inspeCfntDtm }}</td>
                </tr>
                <tr>
                  <th scope="row">대면장소</th>
                  <td>{{ state.inspeCfntDscPlc }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="tip_area">
            영업담당자가 직접 입력한 내용이며, 사실과 다른 경우 전자서명 진행을
            중단하시기 바랍니다.
          </p>
          <!-- 전자서명 영역 -->
          <div class="signature_wrap">
            <div class="btn_signature">
              <button type="button" class="btn_all_clear" @click="allClearPad">
                <span>초기화</span>
              </button>
            </div>
            <MblElcSignaturePad type="name" ref="namePad" />
            <MblElcSignaturePad type="sign" ref="signPad" />
          </div>
          <!-- // 전자서명 영역 -->
          <div class="btn_area">
            <button type="button" class="btn_main type2" @click="cfntDocCnf">
              <span>서류확인</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer :rtrnAnimInsYn="state.rtrnAnimInsYn" />
  </div>
</template>
<script>
import { ref, reactive, inject, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import useDialog from "@/common/dialog";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import MblElcSignaturePad from "@/components/common/MblElcSignaturePad.vue";
export default {
  name: "cfntYnCnf",
  components: {
    Header,
    Footer,
    MblElcSignaturePad,
  },
  setup(props, context) {
    const store = useStore();
    const router = useRouter();
    const axios = inject("axios");
    const dialog = useDialog(inject("$vfm"));

    const state = reactive({
      currDate: util.formatDate(new Date(), "yyyymmdd"),
      yyyymmdd: util.formatDate(new Date(), "yyyy년 mm월 dd일"),
      rtrnAnimInsYn: false,
      trtpeOrgNm: "",
      polhdNm: "",
      cfntDscMd: "",
      cfntDscPlc: "",
      cfntDtm: "",
      inspeCfntDscMd: "",
      inspeCfntDscPlc: "",
      inspeCfntDtm: "",
      opmtLs: [],
    });

    const namePad = ref(null);
    const signPad = ref(null);

    const allClearPad = () => {
      namePad.value.undo();
      signPad.value.undo();
    };

    onMounted(async () => {
      await load();
      util.saveLog("009", "대면설명여부"); // 009 : 화면진입
      if (util.isEmpty(sessionUserInfo) || util.isNull(sessionUserInfo)) {
        // location.go("/mblElcSgn/mblElcSgn.do", "/09");
        router.push({ name: "sessionExpired" });
        return;
      }

      if (
        sessionUserInfo.rpsPdCd == "61139" ||
        sessionUserInfo.rpsPdCd == "61238" ||
        sessionUserInfo.rpsPdCd == "61239"
      ) {
        state.rtrnAnimInsYn = true;
      } else {
        state.rtrnAnimInsYn = false;
      }

      store.commit("elcSgnInf/clearImageData");

      let ctrBasInfCoVo = sessionUserInfo.ctrBasInfCoVo[0];

      if (ctrBasInfCoVo.agplrCd == "") {
        state.trtpeOrgNm = ctrBasInfCoVo.trtpeOrgNm;
      } else {
        state.trtpeOrgNm = ctrBasInfCoVo.agplrNm;
      }

      state.cfntDtm = sessionUserInfo.cfntDtm;
      state.inspeCfntDtm = sessionUserInfo.inspeCfntDtm;
      state.polhdNm = ctrBasInfCoVo.polhdNm;
      state.maInspeNm = sessionUserInfo.maInspeNm;

      try {
        var dscPolhdNm = "";
        for (var i = 0; i < state.polhdNm.length; i++) {
          if (i == 0) {
            dscPolhdNm += state.polhdNm.charAt(i);
          } else if (i == state.polhdNm.length - 1) {
            dscPolhdNm += state.polhdNm.charAt(i);
          } else {
            dscPolhdNm += "*";
          }
        }
        state.polhdNm = dscPolhdNm;
      } catch (ex) {}

      let res = await Promise.all([
        retrieveDmnInf("202003250005"),
        retrieveDmnInf("202003260001"),
        opmtIntz(),
      ]);

      let cdsExplain = res[0].data.row;
      let cdsPlace = res[1].data.row;

      let cdsExplainInfo, cdsPlaceInfo;
      cdsExplainInfo = _.find(cdsExplain, {
        efctVal: sessionUserInfo.cfntDscMdCd,
      });
      if (!_.isEmpty(cdsExplainInfo)) {
        state.cfntDscMd = cdsExplainInfo.efctValNm;
      }

      if (sessionUserInfo.cfntDscPlcCd == "9") {
        state.cfntDscPlc = sessionUserInfo.cfntDscEtcPlc;
      } else {
        cdsPlaceInfo = _.find(cdsPlace, {
          efctVal: sessionUserInfo.cfntDscPlcCd,
        });
        if (!_.isEmpty(cdsPlaceInfo)) {
          state.cfntDscPlc = cdsPlaceInfo.efctValNm;
        }
      }

      cdsExplainInfo = _.find(cdsExplain, {
        efctVal: sessionUserInfo.inspeCfntDscMdCd,
      });
      if (!_.isEmpty(cdsExplainInfo)) {
        state.inspeCfntDscMd = cdsExplainInfo.efctValNm;
      }

      if (sessionUserInfo.inspeCfntDscPlcCd == "9") {
        state.inspeCfntDscPlc = sessionUserInfo.inspeCfntDscEtcPlc;
      } else {
        cdsPlaceInfo = _.find(cdsPlace, {
          efctVal: sessionUserInfo.inspeCfntDscPlcCd,
        });
        if (!_.isEmpty(cdsPlaceInfo)) {
          state.inspeCfntDscPlc = cdsPlaceInfo.efctValNm;
        }
      }

      if (
        _.isEmpty(state.cfntDscMd) ||
        _.isEmpty(state.cfntDscPlc) ||
        _.isEmpty(state.cfntDtm) ||
        _.isEmpty(state.inspeCfntDscMd) ||
        _.isEmpty(state.inspeCfntDscPlc) ||
        _.isEmpty(state.inspeCfntDtm)
      ) {
        dialog
          .alert(
            "대면정보가 누락되었습니다. 마지막으로 수신한 알림톡으로 접속해주시기 바랍니다."
          )
          .then(() => {
            router.push({ name: "sessionExpired" });
          });
        return;
      }
    });

    async function retrieveDmnInf(DmnCode) {
      var param = {};
      param.dmnVal = DmnCode;
      return await axios.json("/retrieveDmnInf.do", param);
    }

    function opmtIntz() {
      var param = {};
      param.prctrNo = sessionUserInfo.prctrNo;
      //출력물 전체 조회
      axios.json("/retrieveElcSgnSndInf.do", param).then(function (result) {
        state.opmtLs = result.data.body;
        state.opmtLs = _.filter(state.opmtLs, function (info) {
          return info.ctnsKdCd == "116314";
        });
        if (state.opmtLs.length == 0) {
          dialog
            .alert("출력물 생성이 실패하였습니다. 취급자에게 문의바랍니다.")
            .then(function () {
              router.push({ name: "cellAth" });
              // location.go("/mblElcSgn/mblElcSgn.do", "/01" );
              return false;
            });
        }
      });
    }

    const cfntDocCnf = () => {
      let namePadData = namePad.value.signaturePad.saveSignature();
      let signPadData = signPad.value.signaturePad.saveSignature();

      if (namePadData.isEmpty || namePadData.data.length == 826) {
        dialog.alert("서명을 해주시길 바랍니다.");
        return false;
      }

      if (signPadData.isEmpty || signPadData.data.length == 826) {
        dialog.alert("서명을 해주시길 바랍니다.");
        return false;
      }

      if (namePadData.data.length < 5000 || signPadData.data.length < 5000) {
        dialog.alert(
          "정확한 성명, 서명이 입력되었는지 확인하시기 바랍니다. (단순 점, 선이 입력된 경우 진행이 불가할 수 있습니다.)"
        );
        return false;
      }

      let param = {};
      param.base64Data = util.replaceAll(
        namePadData.data,
        "data:image/png;base64,",
        ""
      ); //서명 BASE64 데이터
      param.base64Data1 = util.replaceAll(
        signPadData.data,
        "data:image/png;base64,",
        ""
      ); //서명 BASE64 데이터
      param.prctrNo = sessionUserInfo.prctrNo;
      param.orgCd = sessionUserInfo.orgCd;
      param.cfntDscMd = state.cfntDscMd;
      param.cfntDscPlc = state.cfntDscPlc;
      param.inspeCfntDscPlc = state.inspeCfntDscPlc;
      param.inspeCfntDscMd = state.inspeCfntDscMd;
      param.cusNo = sessionUserInfo.cusNo; //피보험자 서명을 위한 고객번호 추가(파일명)

      axios.json("/inspe/transferCusSgnImg.do", param).then(function (result) {
        console.log(result);
        var elcSgnYn = result.data.elcSgnYn;
        if (elcSgnYn == "Y") {
          let param = _.cloneDeep(sessionUserInfo);

          param.opmtCtnsKdCd = "116314";
          param.currentDate = state.currDate;
          param.cfntDscMd = state.cfntDscMd;
          param.cfntDscPlc = state.cfntDscPlc;
          param.inspeCfntDscPlc = state.inspeCfntDscPlc;
          param.inspeCfntDscMd = state.inspeCfntDscMd;

          let ctrBasInfCoVo = sessionUserInfo.ctrBasInfCoVo[0];

          param.sbcpDt = ctrBasInfCoVo.sbcpDt;
          param.cusNm = ctrBasInfCoVo.polhdNm;

          if (ctrBasInfCoVo.agplrCd == "") {
            param.trtpeOrgNm = ctrBasInfCoVo.trtpeOrgNm;
          } else {
            param.trtpeOrgNm = ctrBasInfCoVo.agplrNm;
          }

          let preloadImages = [];

          param.dataId = sessionUserInfo.mblPrtKey;

          axios.json("/inspe/createInspeOpmt.do", param).then((result) => {
            util.fillDocCode(result.data.row, param.opmtCtnsKdCd);

            store.commit("elcSgnInf/pushImageData", result.data.row);

            state.opmtLs = _.map(state.opmtLs, (d, e) => {
              if (result.data.pageNum == e + 1) {
                d.signImageData = result.data.row[e].imageData;
                d.isSignRequired = true;
                d.isAgr = true;
                d.agrImageData =
                  result.data.row[e].imageData.replace(".jpg", "") +
                  "_nosign.jpg";
                preloadImages.push(d.imageData);
                preloadImages.push(d.signImageData);
              }

              return d;
            });

            var images = [];
            function preload(imgList) {
              let promises = [];
              _.each(imgList, (d, i) => {
                images[i] = new Image();
                images[i].src = d;

                promises.push(
                  new Promise((resolve, reject) => {
                    images[i].onload = function (res) {
                      resolve(res);
                    };
                  })
                );
              });
              return Promise.all(promises);
            }

            //-- usage --//
            preload(preloadImages);

            dialog
              .lyorPop(
                "common/dialog/OpmtViewPop.vue",
                { data: state.opmtLs },
                { content: "full" }
              )
              .then((res) => {
                console.log(res);
                if (!_.isNull(res) && !_.isEmpty(res)) {
                  if (res == "success") {
                    // 예 == 피인지 검사용
                    let inspeTrgCoVo = _.filter(
                      store.state.elcSgnInf.elcSgnTrgCoVo,
                      (data) => data.ptyRlCd.indexOf("02") >= 0
                    )[0];

                    //예금주 당사자 존재여부 확인
                    if (inspeTrgCoVo.ptyRlCd.indexOf("71") >= 0) {
                      router.push({ name: "acntInfInp" });
                    } else {
                      router.push({ name: "sbcpDocSgn" });
                    }
                  }
                }
              });
          });
        } else {
          dialog.alert("전송이 실패하였습니다. 다시 진행해주시길 바랍니다.");
          window.location.reload();
        }
      });
    };

    return {
      state,
      load,
      sessionUserInfo,
      namePad,
      signPad,
      allClearPad,
      cfntDocCnf,
    };
  },
  methods: {
    astaFormat(data) {
      if (_.isEmpty(data)) {
        return "";
      } else {
        return (
          data.substr(0, 1) +
          data.substr(1, data.length - 2).replace(/.+?/g, "*") +
          data.substr(data.length - 1)
        );
      }
    },
  },
};
</script>
